module.exports = __webpack_public_path__ + "img/header-3.4eee77e6.jpg";